function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.918 9.513a.844.844 0 00-.002 1.193l5.215 5.226a.844.844 0 001.195-1.191l-4.62-4.62 4.618-4.617a.844.844 0 00-1.191-1.195L6.918 9.513z",
  fill: "#3C8EFF",
  fillRule: "nonzero",
  "data-override": "fill"
});

const SvgArrowLeft = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrowLeft, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;